export const DEFAULT_CAEN_CODE_FOR_ASSOCIATION = '9802';
